<template>
  <skills-multiselect
    v-model="skillSelection"
    :skill-catalog="skillCatalog"
    :label="$t('page.editProfile.skills.label')"
    :placeholder="$t('page.editProfile.skills.placeholder')"
    :search-placeholder="$t('page.editProfile.skills.searchPlaceholder')"
    :create-item-label="$t('page.editProfile.skills.createSkill')"
    @create-skill="onCreateSkill"
    @add-skill="onAddSkill"
    @remove-skill="onRemoveSkill"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  data() {
    return {
      loading: false,
      skillCatalog: [] as string[],
      skillSelection: [] as string[]
    };
  },
  async created(): Promise<void> {
    try {
      this.loading = true;
      await this.loadSkills();
    } catch (e: any) {
      console.error(`Could not load page`, e);
    } finally {
      this.loading = false;
    }
  },
  methods: {
    async loadSkills(): Promise<void> {
      try {
        this.loading = true;
        const [catalog, selection] = await Promise.all([
          this.$api.skills.fetchSkillCatalog(true),
          this.$api.skills.fetchCurrentUserSkills()
        ]);
        this.skillCatalog = catalog;
        this.skillSelection = selection;
      } catch (e: any) {
        console.warn(`Could not load available skills`);
      } finally {
        this.loading = false;
      }
    },
    async onCreateSkill(value: string) {
      await this.onAddSkill(value);
      await this.loadSkills();
    },
    async onAddSkill(value: string) {
      await this.$api.skills.addSkill(value);
    },
    async onRemoveSkill(value: string) {
      await this.$api.skills.deleteSkill(value);
    }
  }
});
</script>

<style lang="scss" scoped></style>
